import React from "react";
import { SEO } from "./SEO";

interface HomeSEOProps {
  title?: string;
  description?: string;
  seoData?: any;
}

export const HomeSEO: React.FC<HomeSEOProps> = ({
  title = "Evefant - Celebra todo",
  description = "Encuentra todo para tu fiesta y nosotros te lo llevamos. Desde decoración con globos, hasta los bocaditos. Delivery en todo Lima.",
  seoData,
}) => {
  // Use the enhanced SEO component with global fallbacks enabled
  return (
    <SEO
      title={seoData?.metaTitle || title}
      description={seoData?.metaDescription || description}
      type="website"
      schema={seoData?.structuredData}
      openGraph={seoData?.openGraph}
      seoData={seoData}
      author="Evefant"
      publisher="Evefant"
      useGlobalFallbacks={true} // Enable global SEO fallbacks
    >
      {/* Additional meta tags specific to home page */}
      <meta
        name="keywords"
        content={
          seoData?.keywords ||
          "evefant, celebraciones, fiestas, delivery, decoración, globos, bocaditos, lima"
        }
      />

      {/* Mobile app tags */}
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta
        name="apple-mobile-web-app-title"
        content="Evefant - Celebra todo"
      />

      {/* Additional social media tags */}
      <meta property="og:site_name" content="Evefant - Celebra todo" />

      {/* Add additional meta tag for proper indexing */}
      <meta name="referrer" content="origin" />

      {/* Preconnect to important third-party domains */}
      <link rel="preconnect" href={process.env.REACT_APP_IMAGE_FOLDER || ""} />
      <link rel="preconnect" href={process.env.REACT_APP_API_URL || ""} />
    </SEO>
  );
};

export default HomeSEO;
